export class Vehicle {
  id?: number
  license?: License
  mileage?: number
  model?: string;
  maker?: string;
  makerLogoUrl?: string;

  public static create(id: number, license?: string, licenseCountryCode?: string) {
    const vehicle = new Vehicle();
    vehicle.id = id;
    if (license && licenseCountryCode) {
      vehicle.license = new License(license, licenseCountryCode);
    }
    return vehicle;
  }
}

export class License {
  countryISO: string;
  license: string;

  constructor(license: string, countryISO: string) {
    this.license = license.toUpperCase();
    this.countryISO = countryISO;
  }

}

export class LicenseRegexCountry {
  countryCode: string;
  regex: RegExp;
  separators?: string[];

  constructor(countryCode: string, regex: RegExp, separators?: string[]) {
    this.countryCode = countryCode;
    this.regex = regex;
    this.separators = separators;
  }

}
